import styles from "./mobile-pricing-features-table.module.scss";
import {
  PricingFeatureBase,
  PricingFeaturesTableProps,
} from "@/components/pages/pricing-a/components/pricing-features/pricing-features.data";

const MobilePricingFeaturesTable = <T extends PricingFeatureBase>({
  title,
  featuresData,
  featureMap,
}: PricingFeaturesTableProps<T>) => {
  return (
    <div className={styles.table_wrapper}>
      {/* Header Rows */}
      <div className={styles.sticky_rows}>
        <div
          className={styles.section_header_sticky_rows}
          data-tooltip-id="featureTitle"
          data-tooltip-content={title}
        >
          {title}
        </div>
        {Object.keys(featureMap).map((feature) => (
          <div key={feature} className={styles.header}>
            {feature}
          </div>
        ))}
      </div>
      {/* Scrolled Rows */}
      <div className={styles.scrolled_rows}>
        {featuresData.map((feature, indexMain) => (
          <div
            key={feature.name + indexMain}
            className={styles.feature_rows_wrapper}
          >
            <div key={feature.name} className={styles.section_header}>
              {feature.name}
            </div>
            {Object.keys(featureMap).map((key, index) => (
              <div key={key + index} className={styles.data}>
                {String(feature[featureMap[key]])}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MobilePricingFeaturesTable;
